import React, { Component } from 'react';
import { VisTypeModel } from './VisTypeModel';
import VisTypePicker from './VisTypePicker';
import PropTypes from 'prop-types';

class VisTypeContainer extends Component {
	constructor(props) {
		super(props);

		this.visTypeModel = VisTypeModel.create({
			filter: this.props.filter
		}, {
			visDefinitions: this.props.visDefinitions
		});
	}

	render() {
		return <VisTypePicker
			className={this.props.visTypeClassName}
			onVisTypeSelected={(visTypeId) => this.props.onVisTypeSelected(visTypeId)}
			model={this.visTypeModel}
			isVizTypeLocked={this.props.isVizTypeLocked}
			selectedVisId={this.props.selectedVisId}
			isExtVis={this.props.isExtVis}
			iconsFeature={this.props.iconsFeature}
		/>;
	}
}

VisTypeContainer.propTypes = {
	onVisTypeSelected: PropTypes.func,
	filter: PropTypes.array,
	visTypeClassName: PropTypes.string,
	isVizTypeLocked: PropTypes.bool,
	selectedVisId: PropTypes.string,
	isExtVis: PropTypes.func,
	visDefinitions: PropTypes.array.isRequired,
	iconsFeature: PropTypes.object.isRequired
};

export default VisTypeContainer;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-type-picker/src/js/VisTypeContainer.js